import styled from "styled-components";
import { EmbedTheme } from "../../utils/embeds";
import { V3Body } from "../Typography";

export const V3PoweredBy = styled(V3Body) <{ $embedTheme: EmbedTheme }>`
    color: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.grey70 : theme.v3.colors.grey70};
    font-size: 12px;
`;